<template lang="pug">
  div
    div(v-if="datagraf && datagraf[0]")
      ods-dataviz-pie(
        :title="title"
        :data="datagraf"
        :show-labels="false"
        :colors="colors"
        render-type="canvas"
        selected-mode="single"
        :animation="true"
        :legend="true"
        :summary="true"
        :summary-text="tag"
        width="100%"
        height="26vh")
        template(slot="toolbox")
          router-link(:to="{ name: linkTo, params: { datagraf: datagraf, totalReal: totalReal }}")
            ods-button(type="text" icon='ods-icon-arrow-right')
    ods-module(v-else :header="title" shadow="never").loaddiv
      h2 {{ $t('noResults') }}
</template>

<script>
export default {
  name: 'SinglePieChart',
  props: {
    datagraf: {
      required: true
    },
    title: {
      required: true
    },
    colors: {
      required: true
    },
    tag: {
      required: true
    },
    totalReal: {
      required: true
    },
    linkTo: {
      required: true
    }
  }
}
</script>

<style lang="scss">
</style>
